import { combineReducers } from '@reduxjs/toolkit';
import usersReducer from '@modules/Users/usersSlice';

const rootReducer = combineReducers({
  users: usersReducer,
  // Add other reducers here
});

export default rootReducer;
